import { TableHead } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const styles = /* istanbul ignore next */ ({ palette }) => ({
  root: {
    background: palette.background.alternative,
    textAlign: 'left',
  },
});

export default withStyles(styles)(TableHead);
